module.exports = ['$scope', '$state', '$phoneModal', '$translate', '$utils', '$ionicPopup', '$location', 'changePasswordService',
  function ($scope, $state, $phoneModal, $translate, $utils, $ionicPopup, $location, changePasswordService) {
    $scope.changePassword = {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    }
    $scope.showOldPassword = false
    $scope.showNewPassword = false
    $scope.showConfirmPassword = false
    // 获取密码策略
    changePasswordService.getPasswordPolicy().then(function (data) {
      $scope.strengthData = data
      $scope.minStrength = data.minStrength
      $scope.passwordTip = data.tip
      $scope.currentPasswordStrength = ''
    }, function () {
    })
    $scope.showPassword = function (type) {
      switch (type) {
        case 1:
          $scope.showOldPassword = !$scope.showOldPassword
          break
        case 2:
          $scope.showNewPassword = !$scope.showNewPassword
          break
        case 3:
          $scope.showConfirmPassword = !$scope.showConfirmPassword
          break
        default:
          break
      }
    }
    // change监听
    $scope.handlePasswordInputChange = function (type) {
      switch (type) {
        case 1:
          break
        case 2:
          refreshPasswordStrengthStatus()
          break
        case 3:
          break
      }
    }
    // focus监听
    $scope.handlePasswordInputFocus = function (type) {
      switch (type) {
        case 1:
          break
        case 2:
          $scope.focuingNewPassword = true
          break
        case 3:
          break
      }
    }
    // blur监听
    $scope.handlePasswordInputBlur = function (type) {
      switch (type) {
        case 1:
          break
        case 2:
          $scope.focuingNewPassword = false
          break
        case 3:
          break
      }
    }
    // 刷新密码强度
    function refreshPasswordStrengthStatus() {
      const strength = getPasswordStrength($scope.changePassword.newPassword, $scope.strengthData.rules)
      $scope.strength_type = `strength-${strength}`
      switch (strength) {
        case 'zero':
          $scope.strength_value = 0
          $scope.strength_text = $translate.instant('LOGIN.WEAK')
          break
        case 'WEAK':
          $scope.strength_value = 25
          $scope.strength_text = $translate.instant('LOGIN.WEAK')
          break
        case 'FAIR':
          $scope.strength_value = 50
          $scope.strength_text = $translate.instant('LOGIN.FAIR')
          break
        case 'GOOD':
          $scope.strength_value = 75
          $scope.strength_text = $translate.instant('LOGIN.GOOD')
          break
        case 'STRONG':
          $scope.strength_value = 100
          $scope.strength_text = $translate.instant('LOGIN.STRONG')
          break
      }
    }
    // 计算密码强度
    function getPasswordStrength(password, rules) {
      let strength = ''
      if (!password) {
        return 'zero'
      }
      const strengthArr = Object.keys(rules)
      for (let i = 0; i < strengthArr.length; i++) {
        if (isPassStrength(password, rules[strengthArr[i]])) {
          break
        } else {
          strength = strengthArr[i]
        }
      }
      return strength
    }
    // 判断密码是否通过指定强度, 返回警告文字表示不通过，返回空字符串表示通过
    function isPassStrength(password, strengthRule) {
      const ruleKeys = Object.keys(strengthRule)
      let warningText = ''
      if (!password) {
        return warningText
      }
      for (let i = 0; i < ruleKeys.length; i++) {
        if (!strengthRule[ruleKeys[i]](password)) {
          warningText = getWarningText(ruleKeys[i])
          break
        }
      }
      return warningText
    }
    // 根据规则返回对应的警告文字
    function getWarningText(rule) {
      const warningText = {
        isOverMinLength: $translate.instant('LOGIN.OVER_MINLENGTH', { count: $scope.strengthData.minLength === 0 ? 1 : $scope.strengthData.minLength }),
        isNoProhibit: $translate.instant('LOGIN.NO_PROHIBIT'),
        isNoSameWithUsername: $translate.instant('LOGIN.NO_SAME_WITH_USERNAME'),
        isDiffCharacter: $translate.instant('LOGIN.DIFF_CHARACTER'),
        isNoConsecutive: $translate.instant('LOGIN.NO_CONSECUTIVE'),
        isIncludeTwoType: $translate.instant('LOGIN.INCLUDE_TWO_TYPE'),
        isIncludeThreeType: $translate.instant('LOGIN.INCLUDE_THREE_TYPE'),
      }
      return warningText[rule]
    }
    // 确定修改密码
    $scope.confirmChangePassword = function () {
      // 先判断新密码与确认密码是否输入一致
      if ($scope.changePassword.confirmPassword !== $scope.changePassword.newPassword) {
        $scope.warningText = $translate.instant('LOGIN.NOT_SAME_PASSWORD')
        return
      }
      // 再判断新密码是否满足密码策略
      $scope.warningText = isPassStrength($scope.changePassword.newPassword, $scope.strengthData.rules[$scope.strengthData.minStrength])
      // 都满足的话就可以进行密码的更改
      if (!$scope.warningText) {
        changePasswordService.changePassword({ tempSid: $state.params.secondAuthTempSid, newPassword: $scope.changePassword.newPassword, oldPassword: $scope.changePassword.oldPassword }).then(function (data) {
          if (data.code === 'S_OK') {
            $utils.$notify.set({message: $translate.instant('SETTING.CHANGE_PASSWORD_SUCCESS')})
            $state.go('frame.setting')
          }
        }, function (error) {
          if (error.code === 'FA_UNAUTHORIZED') {
            $scope.warningText = $translate.instant('SETTING.INCORRECT_OLDPASSWORD')
          }
        })
      }
    }
    $scope.back = function() {
      $state.go('frame.setting')
    }
  }]



// WEBPACK FOOTER //
// ./src/js/setting/changePassword/changePasswordCtrl.js